import { Collapse, Spin, Typography } from 'antd';
import { useRiskHistory } from '@/entities/risk/api/hooks';
import s from './HistoryTab.module.scss';

const { Text } = Typography;

export function HistoryTab() {
  const { data: historyEntries, isLoading: historyLoading } = useRiskHistory();

  return (
    <Collapse
      className={s['root__history-collapse']}
      items={[
        {
          key: 'h',
          label: `История изменений ОПР (${historyEntries?.length ?? 0})`,
          children: historyLoading ? (
            <Spin size="small" />
          ) : !historyEntries?.length ? (
            <Text type="secondary">Нет записей. Создайте или измените карту/мероприятие.</Text>
          ) : (
            <ul className={s['root__history-list']}>
              {historyEntries.map((h, i) => (
                <li key={`${h.date}-${i}`}>
                  {h.date} — {h.action}
                </li>
              ))}
            </ul>
          ),
        },
      ]}
    />
  );
}
